<template>
  <div class="flex flex-col items-center justify-center w-full h-full bg-veturi-main text-white">
    <h1 class="font-bold text-4xl">Página não encontrada</h1>
    <p class="mt-4 text-xl">A página que você requisitou não existe.</p>
    <router-link to="/home">
      <p class="mt-4 text-3xl font-semibold">Clique aqui para recomeçar.</p>
    </router-link>
  </div>
</template>

<script>
export default {

}
</script>
